import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_item_label, _mergeProps({ class: "q-pt-md q-pl-lg" }, _ctx.TEXT_OVERLINE), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('CREATE_MENU.TITLE')), 1)
      ]),
      _: 1
    }, 16),
    _createVNode(_component_q_list, {
      padding: "",
      class: "q-px-sm"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          disable: !_ctx.canCreateBrief,
          clickable: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createBrief()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, _mergeProps({
                  color: "grey-dark",
                  name: _ctx.ICONS_NAME.FOLDER_OUTLINE
                }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('BRIEF.CAP.SING')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["disable"])), [
          [_directive_close_popup]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createLead({ briefId: _ctx.currentBriefId })))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, _mergeProps({
                  color: "grey-dark",
                  name: _ctx.ICONS_NAME.FILE_OUTLINE
                }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('LEAD.CAP.SING')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })), [
          [_directive_close_popup]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          onClick: _ctx.createContact
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, _mergeProps({
                  color: "grey-dark",
                  name: _ctx.ICONS_NAME.CONTACT_OUTLINE
                }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('CONTACT.CAP.SING')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_close_popup]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createMeeting()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, _mergeProps({
                  color: "grey-dark",
                  name: _ctx.ICONS_NAME.CALENDAR_OUTLINE
                }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('MEETING.CAP.SING')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })), [
          [_directive_close_popup],
          [_vShow, _ctx.isManager]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          onClick: _ctx.createAgreement
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, _mergeProps({
                  color: "grey-dark",
                  name: _ctx.ICONS_NAME.AGREEMENT_OUTLINE
                }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('AGREEMENT.CAP.SING')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_close_popup]
        ]),
        (_ctx.isAlliance)
          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: 0,
              clickable: "",
              onClick: _ctx.createAlliance
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, _mergeProps({
                      color: "grey-dark",
                      name: _ctx.ICONS_NAME.ALLIANCE_OUTLINE
                    }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('ALLIANCE.CAP.SING')), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_close_popup]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.importAllowed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_q_separator),
          _createVNode(_component_q_item_label, _mergeProps({ class: "q-pt-md q-pl-lg" }, _ctx.TEXT_OVERLINE), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('CREATE_MENU.IMPORT.TITLE')), 1)
            ]),
            _: 1
          }, 16),
          _createVNode(_component_q_list, {
            padding: "",
            class: "q-px-sm"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.importLead()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, _mergeProps({
                        color: "grey-dark",
                        name: _ctx.ICONS_NAME.FILE_OUTLINE
                      }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('LEAD.CAP.PLUR')), 1)
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _ctx.importContact
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, _mergeProps({
                        color: "grey-dark",
                        name: _ctx.ICONS_NAME.CONTACT_OUTLINE
                      }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('CONTACT.CAP.SING')), 1)
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_close_popup]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _ctx.importMeeting
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, _mergeProps({
                        color: "grey-dark",
                        name: _ctx.ICONS_NAME.CALENDAR_OUTLINE
                      }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('MEETING.CAP.SING')), 1)
                    ]),
                    _: 1
                  }, 16)
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_close_popup],
                [_vShow, _ctx.isManager]
              ])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}